var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext } from 'react';
import { useResponsiveFormLayout } from './useResponsiveFormLayout';
export const FormLayoutDeepContext = createContext({});
export const FormLayoutShallowContext = createContext({});
export const useFormDeepLayout = () => useContext(FormLayoutDeepContext);
export const useFormShallowLayout = () => useContext(FormLayoutShallowContext);
export const useFormLayout = () => (Object.assign(Object.assign({}, useFormDeepLayout()), useFormShallowLayout()));
export const FormLayout = (_a) => {
    var { shallow, children, className, style } = _a, otherProps = __rest(_a, ["shallow", "children", "className", "style"]);
    const { ref, props } = useResponsiveFormLayout(otherProps);
    const deepLayout = useFormDeepLayout();
    const renderChildren = () => {
        const newDeepLayout = Object.assign({}, deepLayout);
        if (!shallow) {
            Object.assign(newDeepLayout, props);
        }
        else {
            if (props.size) {
                newDeepLayout.size = props.size;
            }
            if (props.colon) {
                newDeepLayout.colon = props.colon;
            }
        }
        return (_jsx(FormLayoutDeepContext.Provider, Object.assign({ value: newDeepLayout }, { children: _jsx(FormLayoutShallowContext.Provider, Object.assign({ value: shallow ? props : undefined }, { children: children })) })));
    };
    return (_jsx("div", Object.assign({ ref: ref, style: style }, { children: renderChildren() })));
};
FormLayout.defaultProps = {
    shallow: true,
};
FormLayout.useFormDeepLayout = useFormDeepLayout;
FormLayout.useFormShallowLayout = useFormShallowLayout;
FormLayout.useFormLayout = useFormLayout;
export default FormLayout;
